import { MediaStateItem, MediaStateResponse, HistoryEpisode } from './media-state.types'

const normalizeEpisodes = (input: unknown): HistoryEpisode[] | undefined => {
  if (!Array.isArray(input)) return undefined
  const episodes: HistoryEpisode[] = []
  input.forEach((ep) => {
    if (!ep || typeof ep !== 'object') return
    const rec = ep as Record<string, unknown>
    const idRaw = rec.episodeId ?? rec.tmdbEpisodeId ?? rec.id
    const episodeId = Number(idRaw)
    if (Number.isNaN(episodeId)) return
    const seasonRaw = rec.season ?? rec.seasonNumber
    const episodeRaw = rec.episode ?? rec.episodeNumber
    const titleRaw = rec.episodeTitle ?? rec.title ?? rec.name
    episodes.push({
      episodeId,
      season: Number(seasonRaw) || 0,
      episode: Number(episodeRaw) || 0,
      episodeTitle: typeof titleRaw === 'string' ? titleRaw : '',
    })
  })
  return episodes
}

const normalizeItems = (input: unknown): MediaStateItem[] => {
  if (!Array.isArray(input)) return []
  const items: MediaStateItem[] = []
  input.forEach((item) => {
    if (typeof item === 'number') {
      items.push({
        tmdbId: item,
        mediaType: '',
        title: '',
        genres: [],
      })
      return
    }
    if (!item || typeof item !== 'object') return
    const rec = item as Record<string, unknown>
    const tmdbId = Number(rec.tmdbId)
    if (Number.isNaN(tmdbId)) return
    const normalized: MediaStateItem = {
      tmdbId,
      mediaType: typeof rec.mediaType === 'string' ? rec.mediaType : '',
      title: typeof rec.title === 'string' ? rec.title : '',
      posterPath: typeof rec.posterPath === 'string' ? rec.posterPath : null,
      releaseYear: typeof rec.releaseYear === 'number' ? rec.releaseYear : null,
      genres: Array.isArray(rec.genres) ? rec.genres.filter((g) => typeof g === 'string') as string[] : [],
      episodes: normalizeEpisodes(rec.episodes),
      episodesWatchedCount: typeof rec.episodesWatchedCount === 'number' ? rec.episodesWatchedCount : undefined,
      seasonsWatchedCount: typeof rec.seasonsWatchedCount === 'number' ? rec.seasonsWatchedCount : undefined,
      lastWatchedOnUtc: typeof rec.lastWatchedOnUtc === 'string' ? rec.lastWatchedOnUtc : undefined,
      numberOfEpisodes: typeof rec.numberOfEpisodes === 'number' ? rec.numberOfEpisodes : undefined,
    }
    items.push(normalized)
  })
  return items
}

export const normalizeMediaState = (data: unknown): MediaStateResponse | null => {
  if (!data || typeof data !== 'object') return null
  const obj = data as Record<string, unknown>
  return {
    favorites: normalizeItems(obj.favorites),
    watchlist: normalizeItems(obj.watchlist),
    history: normalizeItems(obj.history),
    stats: typeof obj.stats === 'object' && obj.stats !== null ? obj.stats as MediaStateResponse['stats'] : undefined,
  }
}

export default normalizeMediaState
